/**
 * Fuente única de la navegación. Sistema de fases al estilo de bison-web:
 * subir CURRENT_PHASE (o el `fase` de un link) activa páginas nuevas en
 * navbar y footer sin tocar cada layout.
 */
export const CURRENT_PHASE = 1;

export const NAV_LINKS_ALL = [
  { label: 'Inicio', href: '/', fase: 1 },
  { label: 'Nosotros', href: '/nosotros/', fase: 1 },
  { label: 'Servicios', href: '/servicios/', fase: 1 },
  { label: 'Equipo', href: '/equipo/', fase: 1 },
  { label: 'Experiencia', href: '/experiencia/', fase: 1 },
  { label: 'Blog', href: '/blog/', fase: 2 },
];

export const FOOTER_LINKS_ALL = {
  Navegación: [
    { label: 'Nosotros', href: '/nosotros/', fase: 1 },
    { label: 'Servicios', href: '/servicios/', fase: 1 },
    { label: 'Equipo', href: '/equipo/', fase: 1 },
    { label: 'Experiencia', href: '/experiencia/', fase: 1 },
    { label: 'Blog', href: '/blog/', fase: 2 },
  ],
};

// Enlaces legales — van en la barra inferior del footer cuando entren en fase 2.
export const FOOTER_LEGAL_ALL = [
  { label: 'Privacidad', href: '/privacidad/', fase: 2 },
  { label: 'Términos', href: '/terminos/', fase: 2 },
];

export const filterByPhase = (links, max = CURRENT_PHASE) =>
  links.filter((l) => l.fase <= max);

export const filterGroupsByPhase = (groups, max = CURRENT_PHASE) =>
  Object.fromEntries(
    Object.entries(groups)
      .map(([section, links]) => [section, filterByPhase(links, max)])
      .filter(([, links]) => links.length > 0)
  );
